<template>
  <div style="height: 100%;background-color: #fbfbfb;padding-top: 20px;box-sizing: border-box">
    <div style="height: 50px;margin: 0 20px">
      <el-button type="primary" plain icon="el-icon-plus" @click="add()">新增</el-button>&nbsp;
    </div>
    <div style="max-height: calc(100% - 100px);overflow-y: auto;margin: 0 20px">
      <el-table :data="tableData" v-loading="loading" element-loading-text="加载中，请耐心等待。"
                border style="width: 100%" highlight-current-row ref="singleTable">
        <el-table-column
          type="index"
          label="序号"
          width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="username"
          label="用户名"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          label="所属人员"
          min-width="100"
          align="center">
          <template slot-scope="scope">
            <!--            <span>{{getPersonName(scope.row)}}</span>-->
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="140">
          <template slot-scope="scope">
            <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="edit(scope.row)"></i>
            <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="del(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="totalCells">
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: 'pointsDetails',
  data () {
    return {
      loading: false,
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      totalCells: 0
    }
  },
  created () {
  },
  methods: {
    getTableData () {},
    add () {},
    edit (row) {},
    del (row) {},
    // 页码
    handleSizeChange (val) {
      this.pageSize = val
      // this.getTableData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      // this.getTableData()
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/businessWeChat/pointsDetails.vue